import { render, staticRenderFns } from "./mgText.vue?vue&type=template&id=3d6b3df4&scoped=true&"
import script from "./mgText.vue?vue&type=script&lang=js&"
export * from "./mgText.vue?vue&type=script&lang=js&"
import style0 from "./mgText.vue?vue&type=style&index=0&id=3d6b3df4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6b3df4",
  null
  
)

export default component.exports